import { COLOUR_NAMES } from '../identity.js';

/** The robot colours still free at a table, one swatch each. */
export function ColourPicker({ colours, value, onChange }: {
  colours: string[];
  value: string | null;
  onChange: (colour: string) => void;
}) {
  return (
    <div className="colour-pick" role="radiogroup" aria-label="Robot color">
      {colours.map((colour) => (
        <button
          key={colour}
          type="button"
          role="radio"
          aria-checked={colour === value}
          aria-label={COLOUR_NAMES[colour] ?? colour}
          title={COLOUR_NAMES[colour] ?? colour}
          className={colour === value ? 'chosen' : undefined}
          style={{ background: colour }}
          onClick={() => onChange(colour)}
        />
      ))}
    </div>
  );
}
